export default "__VITE_ASSET__777a9ae2__"